import {
  Avatar,
  Box,
  Button,
  Card,
  FormControlLabel,
  Grid,
  IconButton,
  Radio,
  RadioGroup,
  Step,
  StepConnector,
  StepLabel,
  Stepper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import React, { useState, useEffect, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import back from "../../assets/images/svg/back.svg";
import DashboardTable from "../../components/NewTable/DashboardTable";
import sort from "../../assets/images/svg/sort.svg";
import profile from "../../assets/images/profile.webp";
import email from "../../assets/images/svg/email.svg";
import call from "../../assets/images/svg/call.svg";
import edit from "../../assets/images/svg/edit.svg";
import Tooltip, { TooltipProps, tooltipClasses } from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";
import add from "../../assets/images/svg/add.svg";
import reject from "../../assets/images/svg/reject.svg";
import unblock from "../../assets/images/svg/unblock.svg";
import minus from "../../assets/images/svg/minus.svg";
import returnIcon from "../../assets/images/svg/return.svg";
import dotIcon from "../../assets/images/svg/dot.svg";
import TotalRevenueLineChart from "../../components/customCharts/ClientChart";
import orderpendingicon from "../../assets/images/order-icon-pending.png";
import ordericon from "../../assets/images/svg/pie.svg";
import EditClientModal from "../../components/modals/EditClientModal";
import { $crud } from "../../utils/CrudFactory";
import { BASE_URL } from "../../constants";
import dayjs from "dayjs";
import { formatter, toLocalTime } from "../../helper/functions";

const statusIcon = {
  Active: unblock,
  Blocked: reject,
};

const getStatusStyles = (status) => {
  switch (status) {
    case "Booked":
      return {
        background: "#1ACA6D !important",
        color: "#ffffff",
      };
    case "Processing":
      return {
        background: "#FB970B !important",
        color: "#ffffff",
      };
    case "Delivered":
      return {
        background: "#074F24 !important",
        color: "#ffffff",
      };
    default:
      return {
        background: "#FFF0ED !important",
        color: "rgba(254, 133, 106, 1)",
      };
  }
};

// CUSTOM STEPPER FOR ORDER DETAIL ------------------------------

const CustomStepConnector = () => (
  <StepConnector
    sx={{
      minWidth: "50px",
      "& .MuiStepConnector-line": {
        border: "1px dashed rgba(103, 60, 142, 1)",
      },
    }}
  />
);

// CUSTOM STEPPER FOR ORDER DETAIL ------------------------------

// CUSTOM TOOLTIP ====================================
const CustomTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    minWidth: 140, // Custom maxWidth for Tooltip
    minHeight: 56, // Custom maxWidth for Tooltip
    background: "#795898", // Additional styles if needed
    color: "#fff", // Additional styles if needed
    fontSize: "8px", // Additional styles if needed
    padding: "8px", // Additional styles if needed
    position: "absolute",
    top: "-38px",
    left: "-90px",
    borderRadius: "0",
  },
});

export default function ClientDetail() {
  const location = useLocation();
  const navigate = useNavigate();
  const [client, setClient] = useState(location.state?.selectedClient);
  const [orderData, setOrderData] = useState([]);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const [year, setYear] = useState(new Date().getFullYear());
  const [editclient, setEditClient] = useState(false);
  // STEPS FOR THE STATUS OF ORDER -------------------------------

  useEffect(() => {
    async function fetchClient() {
      try {
        const { data } = await $crud.retrieve("admin/client", {
          customerID: client.customerID,
        });
        setClient(data);
      } catch (e) {
        console.error(e);
      }
    }
    fetchClient();
  }, [client.customerID]);

  const handleBackClick = () => {
    navigate(-1);
  };
  const handleViewAllClick = () => {
    navigate(`/services/orders?clientId=${client.customerID}`);
  };
  const [mergedSteps, setMergedSteps] = useState([]);

  useEffect(() => {
    setClient(location.state?.selectedClient);
  }, [location.state]);

  useEffect(() => {
    // Combine order.positionHistory with existing steps
    const merged = [];

    const accountCreated = {
      label: "Account Created",
      description:
        client.account_created &&
        toLocalTime(client.account_created, "DD MMM YYYY"),
      time:
        client.account_created && toLocalTime(client.account_created, "h:mm A"),

      icon: <img src={add} width="25px" style={{ marginLeft: "8px" }} />,
      reason: "Client Account Created",
      tooltip: true,
      dot: <img src={dotIcon} />,
    };

    if (client && client.blockStatusHistory) {
      client.blockStatusHistory.forEach((historyItem, index) => {
        let icon = (
          <img
            src={statusIcon[historyItem.status] || add}
            alt=""
            width="25px"
            style={{ marginLeft: "8px" }}
          />
        );
        let desc = "";
        let time = "";
        let dot = <img src={dotIcon} />;

        const now = dayjs();

        const diffMs = now.diff(historyItem.updatedAt);
        const diffDuration = dayjs.duration(diffMs);

        const hours = Math.floor(diffDuration.asHours());
        const minutes = diffDuration.minutes();

        desc = toLocalTime(historyItem.updatedAt, "DD MMM YYYY");

        time =
          toLocalTime(historyItem.updatedAt, "h:mm A -") +
          ` ${hours >= 1 ? `${hours}hr` : `${minutes}m`}`;

        merged.push({
          label: historyItem.status,
          description: desc,
          time,
          icon,
          reason: historyItem.reason,
          tooltip: true,
          dot,
        });
      });
    }

    setMergedSteps([accountCreated, ...merged]);
  }, [client]);

  const sortedRows = useMemo(() => {
    let sortableRows = [...orderData];
    if (sortConfig.key !== null) {
      sortableRows.sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
          return sortConfig.direction === "asc" ? -1 : 1;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
          return sortConfig.direction === "asc" ? 1 : -1;
        }
        return 0;
      });
    }
    return sortableRows;
  }, [orderData, sortConfig]);

  const requestSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });
  };

  async function retrieveClientOrders() {
    const { data } = await $crud.retrieve("admin/orders", {
      search: client.customerID,
    });
    return data;
  }

  useEffect(() => {
    retrieveClientOrders().then((res) => {
      // console.log(res.result);
      setOrderData(res.result.slice(0, 5));
      // setTotal(res.total);
    });
    

    // RUNNING THE retrieveData() FUNCTION ---------------------------------
  }, [client]);

  const pendingOrders = client.orders?.filter((obj) => {
    return obj.currentStatus.some((obj) => {
      return obj.status === "Processing" && obj.active === true;
    });
  });


  const orderColumns = [
    {
      id: "orderId",
      label: "Order ID",
      align: "center",
    },
    {
      id: "createdAt",
      label: "Created Date",
      align: "center",
      renderCell: (row) => {
        return toLocalTime(row.createdAt, "DD MMM YYYY, h:mm A");
      },
    },
    {
      id: "currentStatus.status",
      label: "Status",
      align: "center",
      renderCell: (row) => {
        const styles = getStatusStyles(row.currentStatus.status);
        return (
          <Button
            sx={{
              background: styles.background,
              color: styles.color,
              padding: "4px 14px",
              textTransform: "capitalize",
              border: "none",
              fontSize: "10px",
              cursor: "default",
              width: "90px",
              outline: "none !important",
            }}
          >
            {row.currentStatus.status}
          </Button>
        );
      },
    },
  ];

  return (
    <Grid container sx={{ padding: "0 24px" }} spacing={1}>
      <Grid item xs={12}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "start",
            alignItems: "flex-start",
            gap: 1,
          }}
        >
          <IconButton onClick={handleBackClick} sx={{ marginLeft: "-10px" }}>
            <img src={back} />
          </IconButton>
          <Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "start",
                alignItems: "center",
                gap: 6,
              }}
            >
              <Typography
                variant="h5"
                sx={{
                  fontWeight: 700,
                  fontSize: "30px",
                  color: "#673C8E", // Return the value directly
                }}
              >
                Client Details
              </Typography>
            </Box>
          </Box>
        </Box>
      </Grid>

      <Grid item xs={12} md={6} mt={2}>
        <Typography
          variant="h5"
          sx={{
            fontSize: "13px",
            color: "rgba(126, 126, 126, 1)", // Return the value directly
          }}
        >
          Joined On :{" "}
          {toLocalTime(client.account_created, "DD MMM YYYY - h:mm A")}
        </Typography>
      </Grid>
      <Grid item xs={12} md={6} sx={{ textAlign: "right" }}>
        <Button
          variant="contained"
          size="small"
          sx={{
            padding: "6px 65px",
            width: "200px",
            fontWeight: 600,
            borderRadius: "12px",
            fontSize: "16px",
            height: "42px",
            textTransform: "capitalize",
            backgroundColor:
              client.blockStatus === "Active" ? "#61DE9380" : "#F1A29F",
            color: client.blockStatus === "Active" ? "#074F24" : "#9A0707",
            borderColor: "#683C8C",
            boxShadow: "none !important",
            cursor: "default",
          }}
        >
          {client.blockStatus}
        </Button>
      </Grid>

      <Grid item xs={12} md={6}>
        <Card
          sx={{
            borderRadius: "12p",
            padding: "15px",
            display: "flex",
            justifyContent: "start",
            alignItems: "start",
            gap: "21px",
            position: "relative",
            background: "#fff",
          }}
        >
          <IconButton
            onClick={() => setEditClient(true)}
            sx={{
              position: "absolute",
              right: "20px",
              top: "18px",
              background: "rgba(104, 60, 140, 0.35)",
              borderRadius: 0,
              "&:hover": {
                background: "rgba(104, 60, 140, 0.35)",
              },
            }}
          >
            <img src={edit} />
          </IconButton>
          <Box>
            <Avatar
              variant="circle"
              sx={{ width: "170px", height: "170px" }}
              src={client.profile ? client.profile : profile}
            />
            <Typography
              sx={{
                textAlign: "center",
                fontSize: "14px",
                color: "rgba(103, 60, 142, 1)",
                fontWeight: 400,
                mt: 1,
              }}
            >
              {client.customerID}
            </Typography>
          </Box>
          <Box sx={{ width: "100%", marginTop: "-10px" }}>
            <Typography
              sx={{
                fontSize: "36px",
                color: "#000",
                fontWeight: 600,
              }}
            >
              {client.name}
            </Typography>
            <Typography
              variant="h5"
              sx={{
                fontSize: "12px",
                color: "rgba(126, 126, 126, 1)", // Return the value directly
              }}
            >
              Home : {client.location}
            </Typography>
            <Box
              display={"flex"}
              alignItems={"center"}
              justifyContent={"space-between"}
              mt={"10px"}
            >
              <Typography
                sx={{ fontWeight: 600, fontSize: "12px", color: "black" }}
              >
                Enrolled for sales Tax -{" "}
                <span style={{ fontWeight: 400 }}>
                  {client.isEnrolledforsalesTax}
                </span>
              </Typography>
              <Typography
                sx={{ fontWeight: 600, fontSize: "12px", color: "black" }}
              >
                Enrollment date -{" "}
                <span style={{ fontWeight: 400 }}>
                  {toLocalTime(client.enrollmentforTaxDate)}
                </span>
              </Typography>
            </Box>
            {client.isEnrolledforsalesTax === "Yes" && (
              <Box
                display={"flex"}
                alignItems={"center"}
                justifyContent={"space-between"}
                mt={"10px"}
              >
                <Typography
                  sx={{ fontWeight: 600, fontSize: "12px", color: "black" }}
                >
                  Tax Name -{" "}
                  <span style={{ fontWeight: 400 }}>{client.taxName}</span>
                </Typography>
                <Typography
                  sx={{ fontWeight: 600, fontSize: "12px", color: "black" }}
                >
                  Tax ID -{" "}
                  <span style={{ fontWeight: 400 }}>{client.taxID}</span>
                </Typography>
              </Box>
            )}
            <Box
              sx={{
                marginTop: "12px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: 1,
                }}
              >
                <img src={email} />
                <Typography
                  variant="h5"
                  sx={{
                    fontSize: "12px",
                    color: "rgba(23, 26, 31, 1)", // Return the value directly
                  }}
                >
                  {client.email}
                </Typography>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: 1,
                }}
              >
                <img src={call} />
                <Typography
                  variant="h5"
                  sx={{
                    fontSize: "12px",
                    color: "rgba(23, 26, 31, 1)", // Return the value directly
                  }}
                >
                  {client.phone}
                </Typography>
              </Box>
            </Box>

            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginTop: "30px",
              }}
            >
              <Box>
                <Typography
                  variant="h5"
                  sx={{
                    fontSize: "14px",
                    color: "rgba(103, 60, 142, 1)", // Return the value directly
                  }}
                >
                  Last Order Spent
                </Typography>
                <Typography
                  variant="h5"
                  sx={{
                    fontWeight: 700,
                    fontSize: "14px",
                    color: "rgba(103, 60, 142, 1)", // Return the value directly
                  }}
                >
                  {formatter.format(client.lastOrderPrice)}
                </Typography>
              </Box>
              <Box sx={{ textAlign: "right" }}>
                <Typography
                  variant="h5"
                  sx={{
                    fontSize: "14px",
                    color: "rgba(103, 60, 142, 1)", // Return the value directly
                  }}
                >
                  Total Spent Till Date
                </Typography>
                <Typography
                  variant="h5"
                  sx={{
                    fontWeight: 700,
                    fontSize: "14px",
                    color: "rgba(103, 60, 142, 1)", // Return the value directly
                  }}
                >
                  {formatter.format(client.totalSpent)}
                </Typography>
              </Box>
            </Box>
          </Box>
        </Card>
      </Grid>

      {/* CLIENTS HISTORY STEPPER */}
      <Grid item xs={12} md={6}>
        <Box>
          <Typography
            sx={{
              fontSize: "20px",
              color: "rgba(104, 60, 140, 1)",
              fontWeight: 700,
              textAlign: "center",
            }}
          >
            Client History
          </Typography>
          <Box
            sx={{
              border: "1px solid #673C8E",
              padding: "12px",
              marginTop: "6px",
              ml: 2,
              height: "auto",
              maxWidth: "100%",
              overflowX: "auto",
              marginRight: "14px",
            }}
          >
            {mergedSteps.length < 1 ? (
              <Typography textAlign={"center"}>No History Recorded!</Typography>
            ) : (
              <Stepper
                activeStep={3}
                orientation="horizontal"
                sx={{ maxWidth: "55vw" }}
                connector={<CustomStepConnector />}
              >
                {mergedSteps.map((step, index) => (
                  <Step
                    key={index}
                    sx={{ minWidth: "150px", maxWidth: "150px" }}
                  >
                    {step.tooltip ? (
                      <CustomTooltip
                        title={step.reason || "No reason provided"}
                      >
                        <StepLabel
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                          icon={step.icon}
                        >
                          <Typography
                            sx={{
                              textAlign: "center",
                              margin: "8px 0",
                            }}
                          >
                            {step.dot}
                          </Typography>
                          <Typography
                            sx={{
                              color: "rgba(104, 60, 140, 1)",
                              fontSize: "10px",
                              fontWeight: 700,
                              textAlign: "center",
                            }}
                          >
                            {step.label}
                          </Typography>
                          <Typography
                            sx={{
                              color: "black",
                              fontSize: "10px",
                              textAlign: "center",
                            }}
                          >
                            {step.description}
                          </Typography>
                          <Typography
                            sx={{
                              color: "black",
                              fontSize: "10px",
                              textAlign: "center",
                            }}
                          >
                            {step.time}
                          </Typography>
                        </StepLabel>
                      </CustomTooltip>
                    ) : (
                      <StepLabel
                        icon={step.icon}
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <Typography
                          sx={{
                            textAlign: "center",
                            margin: "8px 0",
                          }}
                        >
                          {step.dot}
                        </Typography>
                        <Typography
                          sx={{
                            color: "rgba(104, 60, 140, 1)",
                            fontSize: "10px",
                            fontWeight: 700,
                            textAlign: "center",
                          }}
                        >
                          {step.label}
                        </Typography>
                        <Typography
                          sx={{
                            color: "black",
                            fontSize: "10px",
                            textAlign: "center",
                          }}
                        >
                          {step.description}
                        </Typography>
                        <Typography
                          sx={{
                            color: "black",
                            fontSize: "10px",
                            textAlign: "center",
                          }}
                        >
                          {step.time}
                        </Typography>
                      </StepLabel>
                    )}
                  </Step>
                ))}
              </Stepper>
            )}
          </Box>
        </Box>

        <Box
          sx={{
            background: "#683C8C",
            display: "flex",
            justifyContent: "space-around",
            ml: 2,
            marginRight: "14px",
            marginTop: "10px",
            padding: "4px",
          }}
        >
          <Box>
            <Typography
              sx={{
                fontSize: "10px",
                color: "#fff",
                fontWeight: 400,
                textAlign: "center",
              }}
            >
              Average Rating
            </Typography>
            <Typography
              sx={{
                fontSize: "14px",
                color: "#fff",
                fontWeight: 700,
                textAlign: "center",
              }}
            >
              {client.averageRating}/5
            </Typography>
          </Box>
          <Box>
            <Typography
              sx={{
                fontSize: "10px",
                color: "#fff",
                fontWeight: 400,
                textAlign: "center",
              }}
            >
              Last Order Rating
            </Typography>
            <Typography
              sx={{
                fontSize: "14px",
                color: "#fff",
                fontWeight: 700,
                textAlign: "center",
              }}
            >
              {client.lastOrderRating}/5
            </Typography>
          </Box>
          <Box>
            <Typography
              sx={{
                fontSize: "10px",
                color: "#fff",
                fontWeight: 400,
                textAlign: "center",
              }}
            >
              Average Pickups
            </Typography>
            <Typography
              sx={{
                fontSize: "14px",
                color: "#fff",
                fontWeight: 700,
                textAlign: "center",
              }}
            >
              {client.averagePickups}
            </Typography>
          </Box>
        </Box>
      </Grid>

      {/* order list */}
      <Grid item xs={12} md={5} mt={1} mb={2}>
        <Card sx={{ borderRadius: 0, background: "#fff", height: "100%" }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "end",
              width: "100%",
              padding: "20px",
            }}
          >
            <Box>
              <Typography
                sx={{
                  fontSize: "22px",
                  color: "rgba(103, 60, 142, 1)",
                  fontWeight: 600,
                }}
              >
                Ordered Details
              </Typography>
            </Box>
            <Box>
              <Typography
                sx={{
                  fontSize: "16px",
                  color: "rgba(103, 60, 142, 1)",
                  fontWeight: 700,
                  cursor: "pointer",
                  textTransform: "uppercase",
                }}
                onClick={handleViewAllClick}
              >
                VIEW All
              </Typography>
            </Box>
          </Box>
          <DashboardTable
            columns={orderColumns}
            rows={orderData}
            emptyMessage="No Orders"
            rowSx={{ backgroundColor: "#ffffff" }}
            bodyCellSx={{ color: "#000000" }}
          />
        </Card>
      </Grid>

      <Grid xs={12} lg={7} item mt={1} mb={2}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "start",
            alignItems: "center",
            paddingLeft: "10px",
            marginBottom: "16px",
            gap: 2,
          }}
        >
          <Card
            sx={{
              padding: "8px",
              borderRadius: "14px",
              width: "100%",
              background: "#fff",
            }}
          >
            <Typography
              sx={{
                textAlign: "center",
                fontWeight: 700,
                fontSize: "20px",
                color: "#673C8E", // Return the value directly
                mb: 2,
              }}
            >
              Current Pending Orders
            </Typography>
            <Box
              sx={{ overflowY: "auto", overflowX: "hidden", height: "176px" }}
            >
              {pendingOrders?.length < 1 ? (
                <Typography textAlign={"center"} mt={"30px"}>
                  No Pending Orders
                </Typography>
              ) : (
                pendingOrders?.map((obj) => {
                  return (
                    <Card
                      sx={{
                        background: "#fff",
                        padding: "14px",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        mb: 1,
                        borderRadius: "14px",
                        boxShadow: "none !important",
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "start",
                          gap: 3,
                        }}
                      >
                        <img
                          src={orderpendingicon}
                          alt="orders-icon"
                          style={{ width: "25px", height: "25px" }}
                        />
                        <Box>
                          <Typography
                            sx={{
                              fontWeight: 400,
                              fontSize: "14px",
                              color: "#171A1F", // Return the value directly
                            }}
                          >
                            {obj.orderId}
                          </Typography>
                          <Typography
                            sx={{
                              fontWeight: 400,
                              fontSize: "14px",
                              color: "#171A1F", // Return the value directly
                              // marginBottom: "20px",
                            }}
                          >
                            {toLocalTime(obj.createdAt, "DD MMM YYYY, h:mm A")}
                          </Typography>
                        </Box>
                      </Box>
                      <Box>
                        {/* <IconButton>
                    <MoreVert sx={{ color: "#673C8E" }} />
                  </IconButton> */}
                        <Typography
                          sx={{
                            fontWeight: 400,
                            fontSize: "11px",
                            color: "#171A1F", // Return the value directly
                            // marginBottom: "20px",
                          }}
                        >
                          {obj.pendingPickups}{" "}
                          {obj.pendingPickups > 1 ? "pickups" : "pickup"}
                        </Typography>
                      </Box>
                    </Card>
                  );
                })
              )}
            </Box>
          </Card>
        </Box>
        <Card
          sx={{
            padding: "16px 20px",
            marginLeft: "10px",
            borderRadius: "14px",
            background: "#fff",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              background: "#fff",
            }}
          >
            <Typography
              sx={{
                fontWeight: 700,
                fontSize: "20px",
                color: "#673C8E", // Return the value directly
                // marginBottom: "20px",
              }}
            >
              Total Revenue
            </Typography>
            <Box display={"flex"} alignItems={"center"} gap="12px" px="8px">
              <Box display={"flex"} alignItems={"center"} gap="8px">
                <div
                  style={{
                    backgroundColor: "#683C8C59",
                    width: "12px",
                    height: "12px",
                    borderRadius: "9999px",
                  }}
                ></div>
                <Typography color={"black"} fontSize={"14px"}>
                  {year - 1}
                </Typography>
              </Box>
              <Box display={"flex"} alignItems={"center"} gap="8px">
                <div
                  style={{
                    backgroundColor: "#673C8E",
                    width: "12px",
                    height: "12px",
                    borderRadius: "9999px",
                  }}
                ></div>
                <Typography color="black" fontSize={"14px"}>
                  {year}
                </Typography>
              </Box>
            </Box>
            {/* <RadioGroup
              onChange={(e) => setYear(Number(e.target.value))}
              row
              defaultValue="2025"
            >
              <FormControlLabel
                value={new Date().getFullYear() - 1}
                control={
                  <Radio
                    sx={{
                      color: "rgba(104, 60, 140, 1)",
                      "&.Mui-checked": {
                        color: "rgba(104, 60, 140, 1)",
                      },
                    }}
                  />
                }
                label={new Date().getFullYear() - 1}
              />
              <FormControlLabel
                value={new Date().getFullYear()}
                control={
                  <Radio
                    sx={{
                      color: "rgba(104, 60, 140, 1)",
                      "&.Mui-checked": {
                        color: "rgba(104, 60, 140, 1)",
                      },
                    }}
                  />
                }
                label={new Date().getFullYear()}
              />
            </RadioGroup> */}
          </Box>
          <Box sx={{ overflowX: "scroll", overflowY: "hidden" }}>
            <TotalRevenueLineChart
              data={
                year === new Date().getFullYear()
                  ? client.monthlyOrders?.currentYear
                  : client.monthlyOrders?.previousYear
              }
              year={year}
            />
          </Box>
          {/* <Box sx={{ textAlign: "center", margin: "50px 0" }}>
            <Typography
              sx={{
                fontWeight: 400,
                fontSize: "16px",
                color: "#673C8E", // Return the value directly
                // marginBottom: "20px",
              }}
            >
              No data Yet!
            </Typography>
          </Box> */}
        </Card>
      </Grid>
      {editclient && (
        <EditClientModal
          open={editclient}
          onClose={setEditClient}
          client={client}
          setClient={setClient}
        />
      )}
    </Grid>
  );
}
